import React from "react";
import { Link } from "react-router-dom";
import { Gamepad2, Truck, ShieldCheck, Handshake, Target, ArrowRight } from "lucide-react";

const GAMES = [
  { icon: Truck, name: "Equipment Match", desc: "Match trailers to the freight they haul." },
  { icon: ShieldCheck, name: "Dispatch Control Room", desc: "Make the safe, compliant call under pressure." },
  { icon: Handshake, name: "Rate Negotiation", desc: "Negotiate the broker up without losing the load." },
  { icon: Target, name: "Run Your Dispatch Day", desc: "Book loads and grow revenue in a full sim." },
];

const ArcadeCTA = () => (
  <section className="arcade" id="arcade" data-testid="arcade-section">
    <div className="container">
      <div className="arcade-head">
        <span className="arcade-kicker"><Gamepad2 size={14} /> Free Dispatch Arcade</span>
        <h2>Try the free games — no sign-up</h2>
        <p>Get a real feel for dispatching before you enroll. Four hands-on games, playable right now, straight from our masterclass.</p>
      </div>
      <div className="arcade-grid">
        {GAMES.map((g) => {
          const Icon = g.icon;
          return (
            <div className="arcade-card" key={g.name}>
              <span className="arcade-ico"><Icon size={22} /></span>
              <h3>{g.name}</h3>
              <p>{g.desc}</p>
            </div>
          );
        })}
      </div>
      <div className="arcade-cta">
        <Link to="/games" className="btn btn-arcade" data-testid="arcade-play-btn">
          <Gamepad2 size={18} /> Play the Games Free <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  </section>
);

export default ArcadeCTA;
